<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <h4 class="main-title mb-0">Check List Management</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form>
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <h5 class="my-auto">New Check List Question</h5>
                        </div>
                        <div class="card-body mb-3">
                            <div class="row g-2">
                                <div class="col-md-3">
                                    <label class="form-label">Check Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Enter check list code..."
                                        class="form-control"/>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label">Check Question</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Enter check list name" class="form-control" />
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Type of Entry</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Type of entry..." class="form-control" />
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Default Value</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Default value..." class="form-control" />
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Asset Group</label><span class="text-danger"> *</span>
                                    <select class="form-control">
                                        <option value="">Select</option>
                                        <option>Motor</option>
                                        <option>LT Motor</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="reset" class="btn btn-sm btn-danger me-2"><i class="ri-close-line icon_hgt"></i>
                                BACK</button>
                            <button type="submit" class="btn btn-sm btn-primary"><i
                                    class="ri-save-line icon_hgt"></i>ADD</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <div class="card">
                    <div class="card-body mb-3">
                        <input class="form-control mb-2" type="text"
                            placeholder="Type keyword and press enter key" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Check Code</th>
                                        <th>Check Question</th>
                                        <th>Type of entry</th>
                                        <th>Default value</th>
                                        <th>Asset Group</th>
                                        <th class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="spare, key in spares_available" :key="key">
                                        <td class="text-center">{{ key + 1 }}</td>
                                        <td>{{spare.spare_code}}</td>
                                        <td>{{spare.spare_name}}</td>
                                        <td>{{spare.make}}</td>
                                        <td>{{0}}</td>
                                        <td>{{spare.asset_group}}</td>
                                        <td class="text-center">
                                            <a href="javascript:void(0)" class="text-success me-2"><i
                                                    class="ri-pencil-line icon_hgt"></i></a>
                                            <a href="javascript:void(0)" class="text-danger"><i
                                                    class="ri-delete-bin-line icon_hgt"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            spares_available: [
                {
                    spare_id: 1,
                    spare_code: 'SC-0001',
                    spare_name: 'Bearing',
                    make: 'SKS',
                    asset_group: 'Motor'
                },
                {
                    spare_id: 2,
                    spare_code: 'SC-0002',
                    spare_name: 'Slip Ring',
                    make: 'Kirloskar',
                    asset_group: 'LT Motor'
                },
                {
                    spare_id: 3,
                    spare_code: 'SC-0003',
                    spare_name: 'Bulk Terminal',
                    make: 'Zentom',
                    asset_group: 'Motor'
                }
            ],
        }
    }
}
</script>
